
import { addPermissionReducer } from './admin/addPermission'
import { blockAndUnBlockAdminReducer } from './admin/blockAndUnBlockAdmin'
import { getAdminSupportLogsReducer } from './admin/getAdminLogs'
import { getAdminSupportReducer } from './admin/getAdminSupports'
import { getSingleAdminSupportReducer } from './admin/getSingleAdminSupports'
import { getSuperAdminLogsReducer } from './admin/getSuperAdminLogs'
import { analyticsUserDetailsReducer } from './analytics/analyticsUserDetails'
// import { getAnalyticsMissionDataReducer } from './analytics/'
import { noOfDropedMissionReducer } from './analytics/noOfDropedMission'
import { noOfParticipentReducer } from './analytics/noOfParticipent'
import { noOfQualifiedMissionReducer } from './analytics/noOfQualifiedMission'
import { noOfMissionAttemptsReducer } from './analytics/noOfMissionAttempts'
import { noOfMissionImpressionGenratedReducer } from './analytics/noOfMissionImpressionGenrated'
import { loginUserReducer } from './auth/loginUser'
import { registerUserReducer } from './auth/registerUser'
import { changeCatSeqReducer } from './category/changeCategorySequence'
import { createCategoryReducer } from './category/createCategory'
import { deleteCategoryReducer } from './category/deleteCategory'
import { getCategoryReducer } from './category/getCategory'
import { getSingleCategoryReducer } from './category/getSingleCategory'
import { restoreCategoryReducer } from './category/restoreCat'
import { updateCategoryReducer } from './category/updateCategory'
import { diffentPlatformPublisherReducer } from './dashbaord/diffentPlatformPublisher'
import { getPermissionAndRoleReducer } from './dashbaord/getPermissionAndRole'
import { missionStatsReducer } from './dashbaord/missionStats'
import { toPublisherReducer } from './dashbaord/toPublisher'
import { totalRevenueReducer } from './dashbaord/totalRevenue'
import { userDayWiseReducer } from './dashbaord/userDayWise'
import { uplodImageReducer } from './image/uplodImage'
import { noOfDeletedMissionReducer } from './menu/noOfDeletedMission'
import { noOfLiveMissionReducer } from './menu/noOfLiveMission'
import { approvedPaymentReducer } from './payments/approvedPayment'
import { creditPaymentReducer } from './payments/creditPayment'
import { paymentRequestsReducer } from './payments/paymentRequests'
import { getLogsByIdyReducer } from './profile/getLogsById'
import { getPublisherReducer } from './publisher/getPublisher'
import { verifyPublisherReducer } from './publisher/verifyPublisher'
import { createDefaultQnsReducer } from './question-answer/createDefaultQns'
import { createQuestionAnswerReducer } from './question-answer/createQuestionAnswer'
import { deleteQuestionAnswerReducer } from './question-answer/deleteQuestionAnswer'
import { getAllQuestionAnswerReducer } from './question-answer/getAllQuestionAnswer'
import { getSingleQuestionAnswerReducer } from './question-answer/getSingleQuestionAnswer'
import { restoreQnsReducer } from './question-answer/restoreQns'
import { updateQuestionAnswerReducer } from './question-answer/updateQuestionAnswer'
import { uploadQnsAnsReducer } from './question-answer/uploadQnsAns'
import { changeSubCatSeqReducer } from './sub-category/changeSubCategorySequence'
import { createSubCategoryReducer } from './sub-category/createSubCategory'
import { deleteSubCategoryReducer } from './sub-category/deleteSubCategory'
import { getSingleSubCategoryReducer } from './sub-category/getSingleSubCategory'
import { getSubCategoryReducer } from './sub-category/getSubCategory'
import { restoreSubCategoryReducer } from './sub-category/restoreSubCat'
import { updateSubCategoryReducer } from './sub-category/updateSubCategory'


import { attemptReducer } from './dashbaord/attempt'
import { qualifiedReducer } from './dashbaord/qualified'
import { disqualifiedReducer } from './dashbaord/disqualified'
import { droppedReducer } from './dashbaord/dropped'
import { quitReducer } from './dashbaord/quit'
import { getAllSubCategoryReducer } from './sub-category/getSubAllCategory'




import { getMetaReducer } from './config/getmeta'
import { editMetaReducer } from './config/editmeta'


import { createSupportDataReducer } from './support/createData'
import { deleteSupportDataReducer } from './support/deleteData'
import { updateSupportDataReducer } from './support/updataData'
import { singleSupportDataReducer } from './support/singleData'
import { supportDataReducer } from './support/list'
import { addManegerDetailsReducer } from './publisher/addManegerDetails'

//Partner
import { createPartnerReducer } from './partner/createPartner'
import { allPartnerReducer } from './partner/allPartner'
import { editPartnerReducer } from './partner/editPartner'
import { getSinglePartnerReducer } from './partner/singlePartner'
import { isActivePartnerReducer } from './partner/livePartner'
import { dateWisePartnerRevenueReducer } from './partner/dateWisePartnerRevenue'

//Offer
import { getAllOffersReducer } from './offer/getAllOffers'
import { createOfferReducer } from './offer/createOffer'
import { editOfferReducer } from './offer/editOffer'
import { deleteOfferReducer } from './offer/deleteOffer'
import { makeOfferActiveReducer } from './offer/makeOfferActive'
import { getSingleOfferReducer } from './offer/getSingleOffer'

//User Offer Attempts
import { getAllUserOfferAttemptsReducer } from './userOfferAttempt/getAllUserOfferAttempts'
import { getSingleUserOfferAttemptReducer } from './userOfferAttempt/getSingleUserOfferAttempt'
import { deleteUserOfferAttemptReducer } from './userOfferAttempt/deleteUserOfferAttempt'
// bank
import { bankDataReducer } from './bank/List'
import { bankVerifyReducer } from './bank/Verify'
import { bankDetailReducer } from './bank/Detail'
import { getSinglePublisherReducer } from './publisher/publisherDetails'

//postback

import { getPostbackReducer } from './postback/postback'

//user
import { getUserReducer } from './users/getAdminSupports'
import { blockAndUnBlockUserReducer } from './users/blockAndUnBlockAdmin'

import { totalUsersReducer } from './dashbaord/totalUsers'
import { userDetailReducer } from './users/userDetail'

import { deleteMultipleQuestionAnswerReducer } from './question-answer/deleteMultipleQna'
import { userTransactionReducer } from './users/userTransactions'


//publisher
import { getSinglePublisherAppReducer } from './publisher/getPublisherSingleApp'

import { editSinglePublisherAppReducer } from './publisher/editPublisherSingleApp'
import { publisherRevenueDetailsReducer } from './publisher/publisherRevenueDetails'
import { publisherMonthlyStatsReducer } from './publisher/publisherMonthlyStats'
import { singlePublisherReducer } from './publisher/singlePublisher'
import { verifyAppReducer } from './publisher/appVerify'

//dashboard
import { totalSurveyAttemptReducer } from './dashbaord/totalSurveyAttempt'
import { partnerTotalRevenueReducer } from './dashbaord/partnerTotalRevenue'

//publisher-user
import { publisherUserReducer } from './publisherUser/publisherUser'
import { publisherUserBlackListStatusChangeReducer } from './publisherUser/blackListPartner'
import { date } from 'yup'

//chargeback
import { chargebackReducer } from './chargeback/chargeback'
import { pendingEarningTransactionReducer } from './pendingEarning/pendingEarning'
import { singlePendingTransactionReducer } from './pendingEarning/singlePendingTransaction'
import { clearPendingEarningReducer } from './pendingEarning/clearPendingEarning'
import { allPartnerNoLimitReducer } from './partner/getAllPartnerNoLimit'
import { blockUserFromPartnerReducer } from './publisherUser/blockUserFromPartner'
import { userWidthdrawPauseReducer } from './publisherUser/userWidthdrawPause'
import { userWidthdrawTransactionReducer } from './users/userWidthdrawTransaction'
import { getAllAppReducer } from './app/getAllApp'
import { amountByAdminReducer } from './users/amountByAdmin'
import { pubAmountByAdminReducer } from './publisher/pubAmountByAdmin'
import { dateWiseallPartnersRevenueReducer } from './partner/allPartnerRevenue'
import { allDeviceInfoReducer } from './users/deviceInfo'
import { userFormSameDeviceReducer } from './users/userFromSameDevice'
import { highCovertingSurveyReducer } from './users/highConvertingSurvey'
import { userAttemptedSurveyReducer } from './users/userAttemptedSurvey'
import { singleUserWidthdrawTransactionReducer } from './users/singleUserWidhrawTransaction'
import { singlePublisherUserReducer } from './publisher/parternUsers'
import { allVideoReducer } from './video/allVideo'
import { createVideoReducer } from './video/createVideo'
import { getSingleVideoReducer } from './video/getSingleVideo'
import { editVideoReducer } from './video/editVideo'
import { getPublisherTokenReducer } from './publisher/getPublisherToken'
import { videoStatReducer } from './video/videoStat'
import { userProfilerReducer } from './publisherUser/userProfiler'


export const toolkitReducers = {

    //pending Earning Transaction
    pendingTranasction:pendingEarningTransactionReducer,
    singlePendingTrans:singlePendingTransactionReducer,
    clearPendingEarning:clearPendingEarningReducer,
    //chargeback
    chargebackData:chargebackReducer,
    //login
    loginUser: loginUserReducer,
    registerUser: registerUserReducer,
    // question answer section------>
    getSingleQuestionAnswer: getSingleQuestionAnswerReducer,
    getAllQuestionAnswer: getAllQuestionAnswerReducer,
    createQuestionAnswer: createQuestionAnswerReducer,
    createDefaultQns: createDefaultQnsReducer,
    updateQuestionAnswer: updateQuestionAnswerReducer,
    deleteQuestionAnswer: deleteQuestionAnswerReducer,
    deleteMultipleQuestionAnswer:deleteMultipleQuestionAnswerReducer,
    restoreQns: restoreQnsReducer,
    // linkQnsToMission: linkQnsToMissionReducer,
    uploadQnsAns: uploadQnsAnsReducer,
    // category---------->
    getCategory: getCategoryReducer,
    getSingleCategory: getSingleCategoryReducer,
    createCategory: createCategoryReducer,
    updateCategory: updateCategoryReducer,
    deleteCategory: deleteCategoryReducer,
    changeCatSeq: changeCatSeqReducer,
    restoreCategory: restoreCategoryReducer,
    // sub-category------->
    getAllSubCategory: getAllSubCategoryReducer,
    getSubCategory: getSubCategoryReducer,
    getSingleSubCategory: getSingleSubCategoryReducer,
    createSubCategory: createSubCategoryReducer,
    updateSubCategory: updateSubCategoryReducer,
    deleteSubCategory: deleteSubCategoryReducer,
    changeSubCatSeq: changeSubCatSeqReducer,
    restoreSubCategory: restoreSubCategoryReducer,
   


    //Partner
    createPartner:createPartnerReducer,
    allPartner:allPartnerReducer,
    editPartner:editPartnerReducer,
    singlePartner:getSinglePartnerReducer,
    partnerActive:isActivePartnerReducer,
    dateWisePartnerRevenue:dateWisePartnerRevenueReducer,
    allPartnerWithoutLimit:allPartnerNoLimitReducer,
    partnersRevenue:dateWiseallPartnersRevenueReducer,

    //Offer
    getAllOffers:getAllOffersReducer,
    createOffer:createOfferReducer,
    editOffer:editOfferReducer,
    deleteOffer:deleteOfferReducer,
    makeOfferActive:makeOfferActiveReducer,
    getSingleOffer:getSingleOfferReducer,

    //User Offer Attempts
    getAllUserOfferAttempts:getAllUserOfferAttemptsReducer,
    getSingleUserOfferAttempt:getSingleUserOfferAttemptReducer,
    deleteUserOfferAttempt:deleteUserOfferAttemptReducer,
    
    
    

    // admin
    getAdminSupport: getAdminSupportReducer,
    addPermission: addPermissionReducer,
    getSuperAdminLogs: getSuperAdminLogsReducer,
    getAdminSupportLogs: getAdminSupportLogsReducer,
    getSingleAdminSupport: getSingleAdminSupportReducer,
    blockAndUnBlockAdmin: blockAndUnBlockAdminReducer,
    // analytics
    noOfDropedMission: noOfDropedMissionReducer,
    noOfParticipent: noOfParticipentReducer,
    noOfQualifiedMission: noOfQualifiedMissionReducer,
    noOfMissionAttempts: noOfMissionAttemptsReducer,
    noOfMissionImpressionGenrated: noOfMissionImpressionGenratedReducer,
    analyticsUserDetails: analyticsUserDetailsReducer,
    // getAnalyticsMissionData: getAnalyticsMissionDataReducer,
    userDayWise: userDayWiseReducer,
    // dashboard
    totalAttempt: attemptReducer,
    totalQualified: qualifiedReducer,
    totalDisqualified: disqualifiedReducer,
    totalQuit: quitReducer,
    totalDropped: droppedReducer,
    toPublisher: toPublisherReducer,
    totalUsers: totalUsersReducer,
    totalSurveyAttempt:totalSurveyAttemptReducer,
    partnerTotalRevenue: partnerTotalRevenueReducer,
    // diffentPlatformPublisher: diffentPlatformPublisherReducer,
    getPermissionAndRole: getPermissionAndRoleReducer,
    // menu
    noOfDeletedMission: noOfDeletedMissionReducer,
    noOfLiveMission: noOfLiveMissionReducer,
    // profile
    getLogsByIdy: getLogsByIdyReducer,
    // publisher
    getPublisher: getPublisherReducer,
    verifyPublisher: verifyPublisherReducer,
    getSinglePubliser: getSinglePublisherReducer,
    getPublisherSingleApp:getSinglePublisherAppReducer,
    editPublisherSingleApp:editSinglePublisherAppReducer,
    publisherRevenueDetails:publisherRevenueDetailsReducer,
    publisherMonthlyStats:publisherMonthlyStatsReducer,
    singlePublisher:singlePublisherReducer,
    verifyApp:verifyAppReducer,
    pubAmountByAdmin:pubAmountByAdminReducer,
    publisherTokenInfo:getPublisherTokenReducer,



    // payments
    paymentRequests: paymentRequestsReducer,
    approvedPayment: approvedPaymentReducer,
    creditPayment: creditPaymentReducer,
    // images
    uplodImage: uplodImageReducer,
  
    
    //config meta
    getMeta: getMetaReducer,
    editMeta: editMetaReducer,

    // support knowledge

    singleSupport: singleSupportDataReducer,
    supportList: supportDataReducer,
    deleteSupport: deleteSupportDataReducer,
    createSupport: createSupportDataReducer,
    updateSupport: updateSupportDataReducer,

    //

    addManager: addManegerDetailsReducer,

    //bank
    bankData: bankDataReducer,
    bankDetail: bankDetailReducer,
    bankVerify: bankVerifyReducer,

    //postback

    getPostback: getPostbackReducer,

    // user
    getUser: getUserReducer,
    blockAndUnBlockUser: blockAndUnBlockUserReducer,
    userDetail: userDetailReducer,
    singlePublisherUsers:singlePublisherUserReducer,
    userTransactions:userTransactionReducer,
    widthDrawTransaction:userWidthdrawTransactionReducer,
    amountByAdmin:amountByAdminReducer,
    allDeviceInfo:allDeviceInfoReducer,
    userFormSameDevice:userFormSameDeviceReducer,
    highConvertingSurvey:highCovertingSurveyReducer,
    userAttemptedSurvey:userAttemptedSurveyReducer,
    singleUserWidthdrawTransaction:singleUserWidthdrawTransactionReducer,



    //publisher-user
    publisherUser:publisherUserReducer,
    publisherUserBlackList:publisherUserBlackListStatusChangeReducer,
    blockUserFromPartner:blockUserFromPartnerReducer,
    userWidthdrawPauseDetails:userWidthdrawPauseReducer,
    userProfilerInfo:userProfilerReducer ,

    //app

    appAllList:getAllAppReducer,


    //all Video

    allVideo:allVideoReducer ,
    createVideo:createVideoReducer,
    singelVideo:getSingleVideoReducer ,
    editVideo : editVideoReducer ,
    videoStat:videoStatReducer



}